var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPing = function SvgIconPing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 29.7,
    y1: 77.39,
    x2: 104.93,
    y2: 30.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 39.54,
    y1: 93.15,
    x2: 114.77,
    y2: 46.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 15.26,
    y1: 54.28,
    x2: 90.49,
    y2: 7.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 10.91,
    y1: 47.31,
    x2: 86.14,
    y2: 0.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2.55,
    y1: 33.94,
    x2: 77.79,
    y2: -13.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 14.27,
    y1: 52.7,
    x2: 89.51,
    y2: 5.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 24.5,
    y1: 69.07,
    x2: 99.73,
    y2: 22.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 31.02,
    y1: 79.52,
    x2: 106.26,
    y2: 32.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 20.8,
    y1: 63.15,
    x2: 96.03,
    y2: 16.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 18.17,
    y1: 58.94,
    x2: 93.4,
    y2: 11.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 27.13,
    y1: 73.28,
    x2: 102.36,
    y2: 26.29,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M75,45.93c-.86,0-1.56.7-1.56,1.56v4.07h3.12v-4.07c0-.86-.7-1.56-1.56-1.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.75,54.69h-45.31c-3.45,0-6.25,2.8-6.25,6.25v25c0,3.45,2.8,6.25,6.25,6.25h16.41v4.69h-2.34c-.86,0-1.56.7-1.56,1.56s.7,1.56,1.56,1.56h17.19c.86,0,1.56-.7,1.56-1.56s-.7-1.56-1.56-1.56h-2.34v-4.69h16.41c3.45,0,6.25-2.8,6.25-6.25v-25c0-3.45-2.8-6.25-6.25-6.25ZM74.22,96.88h-6.25v-4.69h6.25v4.69ZM96.88,85.94c0,1.73-1.4,3.12-3.12,3.12h-45.31c-1.73,0-3.12-1.4-3.12-3.12v-25c0-1.73,1.4-3.12,3.12-3.12h45.31c1.73,0,3.12,1.4,3.12,3.12v25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.44,47.49c0-.23-.05-.46-.15-.66-.47.03-.94.04-1.41.04s-.94-.02-1.41-.04c-.1.21-.15.43-.15.66v5.01c0,.86.7,1.56,1.56,1.56s1.56-.7,1.56-1.56v-5.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.51,23.44c0-.86-.7-1.56-1.56-1.56h-4.07c0,1.04-.07,2.09-.2,3.12h4.27c.86,0,1.56-.7,1.56-1.56Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.75,21.88C43.75,9.79,33.96,0,21.88,0S0,9.79,0,21.88s9.79,21.88,21.88,21.88c12.08-.01,21.86-9.8,21.88-21.88ZM29.13,39.16c1.91-2.97,3.2-6.3,3.78-9.78,2.44-.47,4.81-1.29,7.01-2.44-1.56,5.5-5.53,9.99-10.79,12.22ZM30.17,26.71c-2.74.43-5.52.64-8.29.63-2.78,0-5.55-.2-8.29-.63-.4-3.21-.4-6.46,0-9.68,2.74-.43,5.52-.64,8.29-.63,2.78,0,5.55.2,8.29.63.2,1.61.3,3.22.3,4.84,0,1.62-.1,3.23-.3,4.84ZM33.39,26.06c.14-1.35.21-2.75.21-4.19s-.07-2.83-.21-4.19c4.59,1.15,7.24,2.85,7.24,4.19s-2.65,3.04-7.24,4.19ZM39.92,16.81c-2.21-1.15-4.57-1.97-7.01-2.44-.58-3.48-1.87-6.81-3.78-9.78,5.26,2.22,9.23,6.72,10.79,12.22ZM21.88,3.12c3.05,0,6.25,4.07,7.73,10.67-5.13-.68-10.33-.68-15.47,0,1.49-6.6,4.69-10.67,7.73-10.67ZM14.62,4.59c-1.91,2.97-3.2,6.3-3.78,9.78-2.44.47-4.81,1.29-7.01,2.44,1.56-5.5,5.53-9.99,10.79-12.22ZM10.36,17.69c-.14,1.35-.21,2.75-.21,4.19s.07,2.83.21,4.19c-4.59-1.15-7.24-2.85-7.24-4.19s2.65-3.04,7.24-4.19ZM3.83,26.94c2.21,1.15,4.57,1.97,7.01,2.44.58,3.48,1.87,6.81,3.78,9.78-5.26-2.22-9.23-6.72-10.79-12.22ZM14.14,29.96c2.56.34,5.15.52,7.73.51,2.59,0,5.17-.17,7.73-.51-1.49,6.6-4.69,10.67-7.73,10.67s-6.25-4.07-7.73-10.67h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M59.29,25h4.1c-.16-1.04-.16-2.09,0-3.12h-4.1c-.86,0-1.56.7-1.56,1.56s.7,1.56,1.56,1.56Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.56,35.04c-1.04.16-2.09.16-3.12,0v4.1c0,.86.7,1.56,1.56,1.56s1.56-.7,1.56-1.56v-4.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37.58,75h-4.1c.16,1.04.16,2.09,0,3.12h4.1c.86,0,1.56-.7,1.56-1.56s-.7-1.56-1.56-1.56Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M21.88,59.29c-.86,0-1.56.7-1.56,1.56v4.1c1.04-.16,2.09-.16,3.12,0v-4.1c0-.86-.7-1.56-1.56-1.56Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,32.03c4.75,0,8.59-3.85,8.59-8.59s-3.85-8.59-8.59-8.59-8.59,3.85-8.59,8.59c0,4.74,3.85,8.59,8.59,8.59ZM75,17.97c3.02,0,5.47,2.45,5.47,5.47s-2.45,5.47-5.47,5.47-5.47-2.45-5.47-5.47c0-3.02,2.45-5.47,5.47-5.47Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21.88,67.97c-4.75,0-8.59,3.85-8.59,8.59s3.85,8.59,8.59,8.59,8.59-3.85,8.59-8.59c0-4.74-3.85-8.59-8.59-8.59ZM21.88,82.03c-3.02,0-5.47-2.45-5.47-5.47s2.45-5.47,5.47-5.47,5.47,2.45,5.47,5.47c0,3.02-2.45,5.47-5.47,5.47Z"
  })));
};
export default SvgIconPing;